<template>
  <main>
    <header>
      <div class="img">
        <img :src="country.wechat_img" alt="" style="width: 100%; height: 100%">
      </div>
      <figure>
        <div><img :src="country.ImgUrl" alt="" width="100%"> </div>
        <p>{{ country.Name }}</p>
      </figure>
    </header>
    <nav>
      <a :class="{ on: label === null }" @click="label = null">全部</a>
      <a :class="{ on: label === v }" v-for="v in labelList" :key="v" @click="label = v">{{ v }}</a>
    </nav>
    <ul class="list">
      <router-link tag="li" :to="{ name: 'detail', query: { id: v.VisaProductID } }" v-for="v in list" :key="v.VisaProductID" v-show="label === null || label === v.KindName">
        <p class="head">
          <b>{{ v.KindName }}</b>
          <strong>{{ v.min_price }}</strong>
        </p>
        <p class="title">{{ v.Name }}</p>
        <div class="tags">
          <b><i class="icon-shijian00"></i><span>{{ v | getCycle }}</span></b>
          <b v-for="(sub, i) in v.Promises" :key="i"><i class="icon-gouxuan"></i><span>{{ sub }}</span></b>
        </div>
      </router-link>
    </ul>
  </main>
</template>

<script>
export default {
  data () {
    return {
      country: {},
      list: [],
      label: null,
      labelList: []
    }
  },
  created () {
    const { id } = this.$route.query;
    this.getList(id);
  },
  filters: {
    getCycle (item) {
      const day = ~~item.min_days;
      let res;
      if ( day === 0 ) { res = '0~1个工作日' }
      else if ( day < 4 ) { res = `${day - 1}~${day}个工作日` }
      else if ( day >= 4 ) { res = `${day - 2}~${day}个工作日` }
      else { res = '--' }
      return res;
    }
  },
  methods: {
    getList (id = 2) {
      this.$axios.get('/VisaProduct/byCountry/'+id).then(res => {
        const { country, products: list } = res;
        this.country = country;
        this.list = list.map(v => {
          v.Promises = v.Promise.split(',').filter(v => !!v);
          return v;
        });
        this.labelList = list.reduce((arr, v) => {
          const { KindName } = v;
          arr.includes(KindName) === false && arr.push(KindName);
          return arr;
        }, []);
      })
    }
  }
}
</script>

<style scoped src="./list.css"></style>